












import { ToggleBody, ToggleFunction } from '@/utils/classes/ApiController'
import Vue, { PropType } from 'vue'
export default Vue.extend({
  props: {
    item: Object as PropType<ToggleBody>,
    toggle: Function as PropType<ToggleFunction<ToggleBody>>,
    toggleField: {
      type: String,
      default: 'is_active',
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async onChange() {
      try {
        this.loading = true
        await this.toggle(
          {
            uuid: this.item.uuid,
            [this.toggleField]: this.item[this.toggleField],
          },
          this.toggleField,
        )
      } catch {
        this.item[this.toggleField] = !this.item[this.toggleField]
      } finally {
        this.loading = false
      }
    },
  },
})
